// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Y0Bl","right":"styles_right__3Y_ma"};